if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}

/* ------------------------------------------------------------------
   Angel Scents - маха повтарящия се ред "Вдъхновен от".

   Редът вече се показва над заглавието, на мястото на производителя,
   но при част от продуктите остава и като първи абзац в блока с
   нотките. Тук се маха само вторият. Ако го няма, не се пипа нищо.

   Засегнати са около десетина продукта - SEHR, ROYAL BLEND,
   VOUX TURQUOISE и подобни.
   ------------------------------------------------------------------ */
(function () {
  function dropDuplicate() {
    var notes = document.querySelector(
      'product-info.product__info-container > .product__description--notes'
    );
    var vendor = document.querySelector(
      'product-info.product__info-container > .product-vendor-wrapper'
    );
    if (!notes || !vendor) return;
    if (vendor.textContent.indexOf('Вдъхновен') === -1) return;

    var ps = notes.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      if (ps[i].textContent.indexOf('Вдъхновен') > -1) {
        ps[i].remove();
        break;
      }
    }
    if (!notes.textContent.trim()) notes.style.display = 'none';
  }

  function run() { try { dropDuplicate(); } catch (e) {} }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();